<template>
  <v-dialog
    v-model="openWindow"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <span>
            Client: {{ clientName }} &nbsp; &nbsp; Semaine:
            {{ date }}
          </span>
          <v-btn icon @click.native="openWindow = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-iterator
          :items="historyData"
          :items-per-page.sync="itemsPerPage"
          :footer-props="{ itemsPerPageOptions }"
          sort-by="date"
          :sort-desc="true"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.name"
                cols="12"
                sm="6"
                md="6"
                lg="4"
              >
                <v-card
                  class="ma-2"
                  hover
                  ripple
                  @click="historyToCurrent(item.date)"
                >
                  <v-card-title>
                    Date: {{ item.date }} &nbsp;
                    <v-divider></v-divider>
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <tbody>
                        <tr
                          v-for="product in item.data"
                          :key="product.id_produit"
                        >
                          <td>{{ product.pName }}</td>
                          <td>{{ product.pDelivery.lundi }}</td>
                          <td>{{ product.pDelivery.mardi }}</td>
                          <td>{{ product.pDelivery.mercredi }}</td>
                          <td>{{ product.pDelivery.jeudi }}</td>
                          <td>{{ product.pDelivery.vendredi }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
        <v-divider></v-divider>
        <v-data-table
          :items="productsForm"
          :headers="headers"
          hide-default-footer
        >
          <template v-slot:item.lundi="{ item }">
            <v-text-field
              v-model="item.lundi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.mardi="{ item }">
            <v-text-field
              v-model="item.mardi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.mercredi="{ item }">
            <v-text-field
              v-model="item.mercredi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.jeudi="{ item }">
            <v-text-field
              v-model="item.jeudi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.vendredi="{ item }">
            <v-text-field
              v-model="item.vendredi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>
          <v-btn @click="resetForm">Reset</v-btn>

          <v-btn color="primary" @click="createNewDelivery">Soumettre</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "CustomerAccountDeliveryDialog",
  props: [
    "isOpen",
    "store",
    "client",
    "date",
    "products",
    "productsPrice",
    "clientHistory",
    "deliveryDetails",
    "invoicesDetails"
  ],
  data() {
    return {
      historyData: [],
      itemsPerPage: 2,
      itemsPerPageOptions: [2, 4, 6],
      newDeliveryId: null,
      productsForm: [],
      headers: [
        { value: "produit", text: "Produit" },
        { value: "lundi", text: "Lundi", width: 120 },
        { value: "mardi", text: "Mardi", width: 120 },
        { value: "mercredi", text: "Mercredi", width: 120 },
        { value: "jeudi", text: "Jeudi", width: 120 },
        { value: "vendredi", text: "Vendredi", width: 120 }
      ],
      days: ["lundi", "mardi", "mercredi", "jeudi", "vendredi"]
    };
  },
  computed: {
    openWindow: {
      get: function() {
        return this.isOpen;
      },
      set: function(value) {
        this.$emit("update:isOpen", value);
      }
    },
    clientName: function() {
      return typeof this.client !== "undefined" ? this.client.nom : null;
    }
  },
  methods: {
    createNewDelivery: async function() {
      await this.addDelivery();
      this.addDetailsToDelivery();
      this.openWindow = false;
      this.$emit("updateTable");
      this.resetForm();
    },
    addDelivery: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/delivery/list/" +
          this.$store.getters["getStoreId"] +
          "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        const data = {
          store: this.$store.getters["getStoreId"],
          client: this.client.id_client,
          date_envoie: this.date
        };
        axios
          .post(url, data, config)
          .then(d => {
            this.newDeliveryId = d.data.id_commande;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    addDetailsToDelivery: function() {
      const url =
        "ogari/compte-client/api/sales-details/list/" +
        this.$store.getters["getStoreId"] +
        "/";
      const config = {
        headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
      };
      for (let product of this.productsForm) {
        for (let day of this.days) {
          let data = {
            store: this.$store.getters["getStoreId"],
            commande: this.newDeliveryId,
            produit: product.productId,
            quantite: product[day],
            jour: day
          };
          axios.post(url, data, config).catch(error => {
            console.error(error);
          });
        }
      }
    },
    resetForm: function() {
      this.productsForm = [];
      this.products.forEach(p => {
        this.productsForm.push({
          productId: p.id_produit,
          produit: p.nom,
          lundi: 0,
          mardi: 0,
          mercredi: 0,
          jeudi: 0,
          vendredi: 0
        });
      });
    },
    historyToCurrent: function(date) {
      let selectedData = this.historyData.find(h => h.date === date);
      selectedData.data.forEach(d => {
        let productRow = this.productsForm.find(pf => pf.produit === d.pName);
        productRow["lundi"] = d.pDelivery["lundi"];
        productRow["mardi"] = d.pDelivery["mardi"];
        productRow["mercredi"] = d.pDelivery["mercredi"];
        productRow["jeudi"] = d.pDelivery["jeudi"];
        productRow["vendredi"] = d.pDelivery["vendredi"];
      });
    }
  },
  watch: {
    isOpen: function(e) {
      if (e === true) {
        this.productsForm = [];
        let newSeries = [];
        this.products.forEach(p => {
          this.productsForm.push({
            productId: p.id_produit,
            produit: p.nom,
            lundi: 0,
            mardi: 0,
            mercredi: 0,
            jeudi: 0,
            vendredi: 0
          });
        });
        this.clientHistory.forEach(ch => {
          let newDataItem = {
            date: ch.delivery.date_envoie,
            totalSent: ch.invoice.mtn_commande,
            totalLoss: ch.invoice.mtn_perte,
            data: []
          };
          this.products.forEach(p => {
            newDataItem.data.push({
              pName: p.nom,
              pDelivery: {
                lundi: 0,
                mardi: 0,
                mercredi: 0,
                jeudi: 0,
                vendredi: 0,
                total: 0
              },
              pLoss: {
                lundi: 0,
                mardi: 0,
                mercredi: 0,
                jeudi: 0,
                vendredi: 0,
                total: 0
              }
            });
            this.deliveryDetails
              .filter(
                dd =>
                  dd.produit === p.id_produit &&
                  dd.commande === ch.delivery.id_commande
              )
              .forEach(d => {
                let day = d.jour;
                newDataItem.data.find(ndi => ndi.pName === p.nom).pDelivery[
                  day
                ] = d.quantite;
                newDataItem.data.find(ndi => ndi.pName === p.nom).pDelivery[
                  "total"
                ] += d.quantite;
              });
            this.invoicesDetails
              .filter(
                dd =>
                  dd.produit === p.id_produit &&
                  dd.rapport === ch.report.id_rapport_vente
              )
              .forEach(d => {
                let day = d.jour;
                newDataItem.data.find(ndi => ndi.pName === p.nom).pLoss[day] =
                  d.quantite;
                newDataItem.data.find(ndi => ndi.pName === p.nom).pLoss[
                  "total"
                ] += d.quantite;
              });
          });
          newSeries.push(newDataItem);
        });
        this.historyData = newSeries;
      }
    }
  }
};
</script>

<style></style>
